<template>
  <div class="Tools">
    <button>Run Model</button>
  </div>
</template>

<script>

import * as tf from '@tensorflow/tfjs'

// Define a model for linear regression.
const model = tf.sequential()
model.add(tf.layers.dense({ units: 1, inputShape: [1] }))

model.compile({ loss: 'meanSquaredError', optimizer: 'sgd' })

// Generate some synthetic data for training.
const xs = tf.tensor2d([1, 2, 3, 4], [4, 1])
const ys = tf.tensor2d([1, 3, 5, 7], [4, 1])

// Train the model using the data.
model.fit(xs, ys, { epochs: 10 }).then(() => {
  // Use the model to do inference on a data point the model hasn't seen before:
  model.predict(tf.tensor2d([5], [1, 1])).print()
  // Open the browser devtools to see the output
})
// console.log(process.env.NODE_ENV)
// console.log('yoo')
// alert(process.env.NODE_ENV)
export default {
  name: 'Tools',
  components: {
  }
}
</script>
